var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jy-pageBody",class:[_vm.customClass, { 'is-footer': _vm.$scopedSlots.footer }]},[_vm._t("default"),(_vm.$scopedSlots.footer)?_c('div',{staticClass:"footer"},[_vm._t("footer")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }